export const helpRoutes = {
  label: 'Help',
  labelDisable: false,
  children: [
    {
      name: 'Getting started',
      active: true,
      icon: 'list',
      to: '/'
    },
    {
      name: 'About',
      active: true,
      icon: 'bookmark',
      to: '/'
    }
  ]
};

const routes = [helpRoutes];

export default routes;
